export const SORTED_ANALYTIC_BLOCKS = [
    "total",
    "cash",
    "acquiring",
    "nfc",
    "average",
    "count",
];
